import { render, staticRenderFns } from "./SubtestCard.vue?vue&type=template&id=0bbeda4e&"
import script from "./SubtestCard.vue?vue&type=script&lang=js&"
export * from "./SubtestCard.vue?vue&type=script&lang=js&"
import style0 from "./SubtestCard.vue?vue&type=style&index=0&id=0bbeda4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports